// ds-color-ignore-file: system font stack in dev/internal file
"use client"

import { experimentsForPage } from "./experiments-for-page"

/**
 * Editor-only "render as variant" panel. Lists the experiments likely on the
 * current page (then the rest), each variant a button. Selecting one writes the
 * existing `ahead-flag:<flag>` localStorage override (the same QA/devtools path)
 * and reloads, so the page re-renders that arm and the editor can see + edit
 * each variant's copy. No new override mechanism.
 */
export function VariantSwitcher({ page }: { page: string }) {
  const { onPage, others } = experimentsForPage(page)
  const list = [...onPage, ...others]
  if (!list.length) return null

  function force(flag: string, variant: string) {
    try {
      localStorage.setItem(`ahead-flag:${flag}`, variant)
    } catch {}
    window.location.reload()
  }
  function current(flag: string): string | null {
    try {
      return localStorage.getItem(`ahead-flag:${flag}`)
    } catch {
      return null
    }
  }

  return (
    <div
      data-ahead-editor-ui
      style={{
        position: "fixed",
        left: 18,
        top: 64,
        zIndex: 2147483600,
        width: 300,
        background: "#fff",
        borderRadius: 14,
        padding: 12,
        boxShadow: "0 14px 40px rgba(0,0,0,.18)",
        fontFamily: "ui-sans-serif, system-ui",
        maxHeight: "70vh",
        overflow: "auto",
      }}
    >
      <strong style={{ fontSize: 13 }}>⚗ Render as variant</strong>
      {list.map((e) => {
        const onThisPage = onPage.includes(e)
        return (
          <div key={e.flag} style={{ marginTop: 8 }}>
            <div
              style={{
                fontSize: 11,
                fontFamily: "ui-monospace, monospace",
                color: onThisPage ? "#7a4fd0" : "#999",
              }}
            >
              {e.flag}
              {onThisPage ? " · on this page" : ""}
            </div>
            <div
              style={{
                display: "flex",
                gap: 6,
                marginTop: 4,
                flexWrap: "wrap",
              }}
            >
              {e.variants.map((v) => {
                const active = current(e.flag) === v
                return (
                  <button
                    key={v}
                    onClick={() => force(e.flag, v)}
                    style={{
                      border: active ? "2px solid #7a4fd0" : "1px solid #ddd",
                      background: active ? "#f1ecfb" : "#fff",
                      borderRadius: 7,
                      padding: "3px 9px",
                      fontSize: 11,
                      cursor: "pointer",
                    }}
                  >
                    {v}
                  </button>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
